<template>
    <v-dialog v-model="dialog" persistent>
      <v-card light>
        <v-card-title class="headline">
            <v-icon v-if="showicon" color="red" light>warning</v-icon> &nbsp;
            {{ $t(error.title) }}</v-card-title>
        <v-card-text>{{ $t(error.message) }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="close">{{ $t('alerts_accept') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ErrorModal',
    props: {
        dialog: {required: true, default: true},
        error: {type: Object},
        showicon:{default:true}
    },
    methods: {
        ...mapActions([
            'logOut'
        ]),
        close(){
          this.$emit('close')
            /*

            // Aqui hace cosas al cerrar el modal dependiendo el codigo de error
            switch(this.error.code){
                case 401:
                    this.logOut()
                break;
                default:
                    this.$emit('close')
                break;
            }*/

        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/helpers/modals/ErrorModal.vue